import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { HiOutlineEye, HiOutlineEyeOff, HiCheckCircle } from 'react-icons/hi'
import brand from '../brand'
import AuthenticationService from '../service/AuthenticationService.js'
import '../css/auth.css'

// Login, register, forgot-password and signed-out pages. Phones: one card. Desktop: a brand panel beside the form.
const AuthLayout = ({ title, subtitle, children, footer, steps }) => {
    const perks = (brand.home && brand.home.perks) || []
    return (
        <main className='mv-auth'>
            <aside className='mv-auth-brand' aria-hidden='true'>
                <span className='mv-auth-brand-logo'>
                    <img src={brand.logo} alt='' className={brand.logoCrop ? 'is-cropped' : ''} />
                </span>
                <p className='mv-auth-brand-title'>
                    {brand.hero.title} {brand.hero.titleEmphasis && <em>{brand.hero.titleEmphasis}</em>}
                </p>
                <p className='mv-auth-brand-text'>{brand.description}</p>
                {perks.length > 0 &&
                    <ul className='mv-auth-perks'>
                        {perks.map(perk => <li key={perk.title}><HiCheckCircle /> {perk.title}</li>)}
                    </ul>}
                <span className='mv-auth-blob mv-auth-blob-1' />
                <span className='mv-auth-blob mv-auth-blob-2' />
            </aside>

            <div className='mv-auth-side'>
                <div className='mv-auth-card'>
                    <Link to='/' className={'mv-auth-logo' + (brand.logoCrop ? ' is-cropped' : '')} aria-label={brand.name + ' home'}>
                        <img src={brand.logo} alt={brand.fullName} />
                    </Link>
                    {steps}
                    <h1 className='mv-auth-title'>{title}</h1>
                    {subtitle && <p className='mv-auth-sub'>{subtitle}</p>}
                    {children}
                </div>
                {footer && <p className='mv-auth-footer'>{footer}</p>}
            </div>
        </main>
    )
}

// "or continue with email" line between the Google button and the email form
export const AuthDivider = ({ children }) => (
    <div className='mv-auth-divider' role='separator'><span>{children}</span></div>
)

// Same for email login, sign-up and Google: store the session, then onboarding routes customers to the shop
// and admins/managers to the dashboard.
export const finishSignIn = (history, data) => {
    AuthenticationService.saveLogInCount()
    AuthenticationService.registerSuccessfulUser(data.accessToken, data.userType)
    history.push('/userDetails')
}

export const PasswordInput = ({ id, value, onChange, placeholder, autoComplete, invalid, describedBy }) => {
    const [visible, setVisible] = useState(false)
    return (
        <div className='mv-password'>
            <input
                id={id}
                className='mv-input'
                type={visible ? 'text' : 'password'}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                autoComplete={autoComplete}
                aria-invalid={invalid ? 'true' : undefined}
                aria-describedby={describedBy}
            />
            <button type='button' className='mv-password-toggle' onClick={() => setVisible(v => !v)}
                aria-label={visible ? 'Hide password' : 'Show password'} aria-pressed={visible}>
                {visible ? <HiOutlineEyeOff /> : <HiOutlineEye />}
            </button>
        </div>
    )
}

export const FieldError = ({ id, message }) =>
    message ? <span className='mv-field-error' id={id}>{message}</span> : null

// Pulls a readable message out of an axios error from the auth APIs.
export const apiErrorMessage = (error, fallback) => {
    const data = error?.response?.data
    if (!error?.response) return 'We could not reach the server. Please check your connection.'
    if (typeof data === 'string' && data.trim()) return data
    return data?.message || data?.msg || fallback
}

export const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(email).trim())

export default AuthLayout
